import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Form, message, Select} from 'antd';
import {modal} from 'icsoc-antd-ex';
import tDetailActions from 'Actions/taskManage/detail';

const {ModalSize} = modal;
const {Option} = Select;
const FormItem = Form.Item;
const formItemLayout = {labelCol: {span: 5}, wrapperCol: {span: 19}};

class ReCallModal extends Component {
  // 点击确定
  handleSubmit = () => {
    const {
      actions,
      setReCallModalVisible,
      form: {validateFields},
      getTableList,
      searchData,
    } = this.props;
    validateFields((err, values) => {
      if (!err) {
        actions
          .reCall({...values})
          .then(res => {
            if (res.payload.code === 200) {
              message.success(res.payload.msg);
            }
          })
          .finally(() => {
            getTableList(searchData);
            setReCallModalVisible();
          });
      }
    });
  };

  taskChange = v => {
    const {actions} = this.props;
    actions.getBatchOptions(v);
  };

  render() {
    const {
      setReCallModalVisible,
      form: {getFieldDecorator},
      taskNameOptions,
      batchList,
      reCallModalData,
      reCallModalData: {taskInfoId = '', batchId = ''},
      pageType,
    } = this.props;

    return (
      <ModalSize
        title="一键重呼"
        centered
        maskClosable={false}
        visible
        onOk={this.handleSubmit}
        onCancel={setReCallModalVisible}>
        <Form>
          <FormItem {...formItemLayout} label="选择任务名称：">
            {getFieldDecorator('taskInfoId', {
              initialValue: taskInfoId || undefined,
              rules: [{required: true, message: '请选择任务名称！'}],
            })(
              <Select
                showSearch
                allowClear
                placeholder="请选择任务"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                onChange={this.taskChange}>
                {Array.isArray(taskNameOptions)
                  ? taskNameOptions.map(({taskId, taskName}) => (
                      <Option value={taskId} key={taskId}>
                        {taskName}
                      </Option>
                    ))
                  : null}
              </Select>,
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="选择批次：">
            {getFieldDecorator('batchId', {
              initialValue: batchId || undefined,
              rules: [{required: true, message: '请选择批次！'}],
            })(
              <Select placeholder="请选择">
                {Array.isArray(batchList)
                  ? batchList.map(({id, batchName}) => (
                      <Option value={id && parseInt(id, 10)} key={id}>
                        {batchName}
                      </Option>
                    ))
                  : null}
              </Select>,
            )}
          </FormItem>
        </Form>
      </ModalSize>
    );
  }
}

const mapStateToProps = ({taskManageDetail}) => ({
  reCallModalData: taskManageDetail.reCallModalData,
  batchList: taskManageDetail.batchList,
  searchData: taskManageDetail.searchData,
  taskNameOptions: taskManageDetail.taskNameOptions,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tDetailActions, dispatch),
});
const ReCallModalWrap = Form.create()(ReCallModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReCallModalWrap);
